import { ContainedButton, PrimaryButton } from '@components/Buttons';
import { Col } from '@components/Layout/Col';
import { Container } from '@components/Layout/Container';
import { Row } from '@components/Layout/Row';
import { Link } from '@components/Link';
import { Trans } from '@components/Trans';
import { useDuplicateOrder } from '@containers/Apparel/Orders/hooks/useDuplicateOrder';
import { useReactRouter } from '@hooks/useRouter';
import Typography from '@material-ui/core/Typography/Typography';
import { Layout } from '@packages/layout';
import { IF } from '@packages/react/lib/if';
import React from 'react';
import styled from 'styled-components';
import { useInstantQuoteToDesignRequest } from './hooks/useInstantQuoteToDesignRequest';

const Style = styled(Row)`
    && {
        padding-top: 100px;

        .headline {
            font-size: 35px;
            margin-bottom: 14px;
        }

        .link-button {
            border-radius: 2px;
            text-align: center;
            min-width: 174px;
            margin: 6px;
            &:hover {
                color: #fff;
            }
        }
    }
`;

export default function InstantQuoteConfirmation() {
    const { match, location } = useReactRouter() as any;
    const { state } = location;
    const { fromCart } = (state ?? {}) as any;
    const { has_only_sizing_kits } = (state ?? {}) as any;
    const { handlePreFillDesignRequest, isLoadingPrefill } = useInstantQuoteToDesignRequest();

    const { handleDuplicateOrder, isDuplicating } = useDuplicateOrder();

    return (
        <Layout title={'Submission Received'} noSidebar>
            <Container responsive>
                <Style justify={'center'}>
                    <Col xs={12} md={8} justify={'center'} direction={'column'}>
                        <Typography variant={'h1'} className={'headline'} align={'center'}>
                            <Trans>Your Quote has been Saved!</Trans>
                        </Typography>

                        <Typography
                            variant={'subtitle1'}
                            color={'textSecondary'}
                            align={'center'}
                            style={{ marginBottom: 24 }}
                        >
                            We sent you an email confirmation with your quote details. <br />
                            You can see your quote in the <Link to="/quotes">Quotes</Link> section of your client panel.
                        </Typography>

                        <Row justify={'center'}>
                            {fromCart ? (
                                <>
                                    <PrimaryButton component={Link} to={'/my-cart/review'}>
                                        Back to cart
                                    </PrimaryButton>
                                    {IF(
                                        !has_only_sizing_kits,
                                        <PrimaryButton onClick={handlePreFillDesignRequest(match.params.id)}>
                                            Request designs
                                        </PrimaryButton>,
                                    )}
                                </>
                            ) : (
                                <>
                                    <ContainedButton
                                        background={'primary'}
                                        color={'#fff'}
                                        loading={isLoadingPrefill}
                                        size={'large'}
                                        className={'link-button'}
                                        onClick={handlePreFillDesignRequest(match.params.id)}
                                    >
                                        <Trans>Create Designs</Trans>
                                    </ContainedButton>
                                    <ContainedButton
                                        background={'primary'}
                                        color={'#fff'}
                                        loading={isDuplicating}
                                        className={'link-button'}
                                        onClick={handleDuplicateOrder(
                                            {
                                                order_id: match.params.id,
                                                type: 'New Order',
                                            },
                                            'shipping',
                                        )}
                                    >
                                        <Trans>Place Order</Trans>
                                    </ContainedButton>
                                </>
                            )}
                        </Row>
                    </Col>
                </Style>
            </Container>
        </Layout>
    );
}
